// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IAuthenticationResponseModel {
    static getAttributeTypeMap() {
        return IAuthenticationResponseModel.attributeTypeMap;
    }
}
IAuthenticationResponseModel.discriminator = undefined;
IAuthenticationResponseModel.additionalProperties = false;
IAuthenticationResponseModel.attributeTypeMap = [
    {
        "name": "status",
        "baseName": "status",
        "type": "AuthenticateStatus"
    },
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "IAuthenticationData"
    },
];
//# sourceMappingURL=iAuthenticationResponseModel.js.map